import React from 'react';
import { Route } from 'react-router';
import createCustomRoute from 'hocs/createCustomRoute';
import OnlineStore from '../../pages/OnlineStore/OnlineStore';
import GoStore from '../../pages/OnlineStore/GoStore/GoStore';
import Google from '../../pages/OnlineStore/Google/Google';
import FacebookShop from '../../pages/OnlineStore/FacebookShop/FacebookShop';

const OnlineStoreRoutes = createCustomRoute('OnlineStoreRoutes', props => {
  const {
    canVisitFacebookOnlineStore,
    canVisitGoogleOnlineStore,
    ...rest
  } = props;

  return (
    <Route {...rest} component={OnlineStore}>
      <Route path="gostore" component={GoStore} />
      <Route
        path="facebook-instagram-shop"
        component={FacebookShop}
        onEnter={canVisitFacebookOnlineStore}
      />
      <Route
        path="google-shopping"
        component={Google}
        onEnter={canVisitGoogleOnlineStore}
      />
    </Route>
  );
});

export default OnlineStoreRoutes;
